import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { notifications } from '@mantine/notifications';
// I18n
import { useTranslation } from 'react-i18next';
import { TResponseApi } from 'shared/types';
import { TMutationConfig } from '@lib/react-query';

export const remove = (
	id: string
): Promise<{
	response: TResponseApi;
}> => {
	return apiClient.delete(`/media/${id} `);
};

type TUseRemovePrivatePictureOptions = {
	mutationConfig?: TMutationConfig<typeof remove>;
};
export const useRemovePrivateMedia = ({
	mutationConfig,
}: TUseRemovePrivatePictureOptions = {}) => {
	const { onSuccess, ...restConfig } =
		mutationConfig || {};

	const { t } = useTranslation();
	const { mutate, isPending: isLoading } = useMutation({
		mutationFn: remove,
		onSuccess: (...args) => {
			onSuccess?.(...args);
		},
		onError: (error: any) => {
			notifications.show({
				title: 'Error',
				message: t(`api.${error.type}`),
				color: 'error',
			});
		},
		...restConfig,
	});

	return { mutate, isLoading };
};
